import { size } from "lodash"
import PropTypes from "prop-types"
import { Dns } from "@mui/icons-material"
import Resource from "../resource"
import EditWatchlist from "components/edit-watchlist"
import { PERMISSION_LEVEL, ROLE } from "helpers/shapes"
import { PERMISSION_LEVELS, hasPermission } from "helpers/permissions"
import { ButtonAction, LinkAction } from "../card-actions"
import { renderAction } from "../../helpers"
import saveRecentResources from "hocs/saveRecentResources"
import { getWatchlistMenuItems } from "modules/watchlist-root/selectors/menu"

export default function Watchlist({ handlers, resource, permissionLevel, openDialog, trackResourceEvent, toggleFavorite, account, role, isOpPro, models, dispatch }) {
  const openEditDialog = () => {
    const EditWatchlistWithRecentResources = saveRecentResources(EditWatchlist, "id")
    openDialog({
      title: "Edit Watchlist",
      content: <EditWatchlistWithRecentResources
        heapSubmitId="watchlist-create-watchlist"
        id={resource.id}
        description={resource.description}
        name={resource.name}
        alias={resource.alias}
        saveWatchlist={handlers.updateWatchlist}
      />,
    })
  }

  const trackActionClick = (type, action) => {
    return () => {
      trackResourceEvent({
        trackType: "resources-secondary-link",
        trackPayload: {
          actionType: type,
          resourceType: "watchlist",
        },
      })
      if (action) action()
    }
  }

  const computeAction = () => {
    const { noData, description, id } = resource
    const canEditWatchlist = role === "admin" || hasPermission(permissionLevel, PERMISSION_LEVELS.WRITE)
    const noModels = !size(models)

    return renderAction([{
      condition: canEditWatchlist && noData,
      render: <LinkAction disabled={noModels} onClick={trackActionClick("positions")} to={`/${account}/watchlist/${id}/upload`}>Upload Positions</LinkAction>,
    }, {
      condition: canEditWatchlist && !description,
      render: <ButtonAction disabled={noModels} onClick={trackActionClick("description", openEditDialog)}>Add description</ButtonAction>,
    }])
  }
  return <Resource {...{
    url: `/${account}/watchlist/${resource.id}`,
    account,
    toggleFavorite,
    trackResourceEvent,
    resource,
    resourceType: "watchlist",
    resourceIcon: <Dns />,
    permissionLevel,
    menuItems: getWatchlistMenuItems(account, resource),
    action: computeAction(),
    models,
    isOpPro,
    dispatch,
  }}
  />
}

Watchlist.propTypes = {
  handlers: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  permissionLevel: PERMISSION_LEVEL.isRequired,
  openDialog: PropTypes.func.isRequired,
  trackResourceEvent: PropTypes.func.isRequired,
  toggleFavorite: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  role: ROLE.isRequired,
  isOpPro: PropTypes.bool.isRequired,
  models: PropTypes.object,
  dispatch: PropTypes.func,
}
